// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__1t9yz","row":"ProcedureTreatmentSummary_row__302tT"};